import Cookies from 'js-cookie'

const serviceToken = {
	get: () => Cookies.get('serviceToken'),
	set: t => Cookies.set('serviceToken', t),
	delete: () => Cookies.remove('serviceToken')
}

export default serviceToken